import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import { tokens, select_style, GET, PUT, validate, getStorage, success_url, loading } from "../../components/CustomComponent.js";
import React, { Component } from "react";
import Resizer from "react-image-file-resizer";
import Select from "react-select";
import province from "../../components/province.json";

const create_r = getStorage("role_detail")?.find(i => i.name === "manage-water")?.role[1] === 1;

const ARRAY_ADDRESS = province.map((e) => ({
  value: e.ID, label: `${e.SUB_DISTRICT}, ${e.DISTRICT}, ${e.ROVINCE}`, zipcode: e.ZIPCODE
}));

export default class ManageWater extends Component {
  state = {
    project_id: getStorage("project_id"), project_name: "", project_number: "",
    address_detail: "", address_id: null, province: "", post_code: "",
    phone_number: "", tax_number: "", picture: "", picture_paper: ""
  };

  componentDidMount() {
    loading(false);
    this.GetProject();
  }

  toDataUrl = async (url) => {
    try {
      let res = await fetch(url);
      let blob = await res.blob();
      return await new Promise((resolve) => {
        let reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(",")[1]);
        reader.readAsDataURL(blob);
      });
    } catch { return global.logo; }
  };

  GetProject = async () => {
    loading(true);
    let r = await GET(tokens, `v1/TH/project-manage/detail/${this.state.project_id}`, null);
    if (r?.status) {
      let d = r.data.data;
      this.setState({
        project_name: d.project_name || "", project_number: d.project_number || "",
        address_detail: d.address_detail || "",
        address_id: d.address_id ? ARRAY_ADDRESS.find(e => e.value == d.address_id) : null,
        post_code: d.address_obj?.ZIPCODE || "", phone_number: d.phone_number || "", tax_number: d.tax_number || "",
        picture: d.picture ? await this.toDataUrl(d.picture) : "",
        picture_paper: d.picture_paper ? await this.toDataUrl(d.picture_paper) : "",
      });
      localStorage.setItem("picture_paper", d.picture_paper);
    }
    loading(false);
  };

  Update = async () => {
    const { project_id, project_name, project_number, address_id, address_detail, phone_number, tax_number, picture, picture_paper } = this.state;
    if (validate(this.state, ["project_number", "project_name", "address_detail", "address_id", "post_code", "phone_number", "tax_number"])) return;
    
    loading(true);
    let data = { project_id, project_name, project_number, address_id: address_id?.value ?? "", address_detail, phone_number, tax_number, picture, picture_paper };
    let r = await PUT(tokens, "v1/TH/project-manage/update", data);
    if (r?.status) success_url("/profile");
    loading(false);
  };

  handlePhoto = (e, field) => {
    if (!e.target.files[0]) return;
    Resizer.imageFileResizer(e.target.files[0], 128, 128, "JPG", 100, 0, (uri) => {
      this.setState({ [field]: uri.split(",")[1] });
    }, "base64");
  };

  inp = (lbl, key, type = "text", max = null, ro = false, isNum = false) => (
    <div className="w-100 d-flex align-items-center mb-3">
      <label className="wpx-140 mb-0">{lbl}:</label>
      <input className="form-control border-0 bg-contain" type={type} maxLength={max} placeholder="กรอกข้อมูล" value={this.state[key]} readOnly={ro}
        onChange={(e) => this.setState({ [key]: isNum ? e.target.value.replace(/\D/g, "") : e.target.value })} />
    </div>
  );

  imgBox = (lbl, key) => {
    const val = this.state[key];
    return (
      <div className="w-100 d-flex align-items-center mb-3">
        <label className="wpx-140 mb-0">{lbl}:</label>
        {!val ? (
          <button className="btn btn-outline-primary w-100" onClick={() => document.getElementById(key).click()}>นำเข้าไฟล์</button>
        ) : (
          <div className="card p-3 align-items-center text-center w-100 position-relative">
            <img alt="โครงการ" src={`${val.includes("http") ? val.replace("//media","/media") : val.includes(";base64,") ? val : `data:image/png;base64,${val}`}`} className="wpx-200 img-responsive" />
            <div className="wpx-32 hpx-32 rounded-circle bg-danger text-white icon text-24 d-flex justify-content-center align-items-center position-absolute pointer" style={{ right: -6, top: -6 }} onClick={() => this.setState({ [key]: "" })}>{"\uf00d"}</div>
          </div>
        )}
        <input className="d-none" id={key} type="file" accept="image/*" onChange={(e) => this.handlePhoto(e, key)} />
      </div>
    );
  };

  render() {
    const s = this.state;
    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ตั้งค่า" page3="จัดการอัตราค่าน้ำ" />
        <div className="body">
          <div className="px-3 pt-3 pb-5">
            <div className="col-12 col-sm-10 col-md-8 col-lg-10 col-xl-8 col-xxl-5 mx-auto">
              <div className="card border-0 bg-gray p-3 mb-3"><h4 className="mb-0"><b>โปรไฟล์</b></h4></div>
              <div className="card border-0 px-3 pt-3 mb-3">
                {this.inp("รหัสโครงการ", "project_number", "text", 4, false, true)}
                {this.inp("ชื่อโครงการ", "project_name")}
                <div className="w-100 d-flex mb-3">
                  <label className="wpx-140 mb-0">ที่อยู่:</label>
                  <textarea className="form-control border-0 bg-contain" placeholder="กรอกข้อมูล" value={s.address_detail} onChange={(e) => this.setState({ address_detail: e.target.value })} />
                </div>
                <div className="w-100 d-flex align-items-center mb-3">
                  <label className="wpx-140 mb-0">ตำบล อำเภอ จังหวัด:</label>
                  <Select className="form-control border-0 bg-contain select-search" styles={select_style} options={ARRAY_ADDRESS} placeholder="-- เลือก --" value={s.address_id} isClearable onChange={(e) => this.setState({ address_id: e, post_code: e ? e.zipcode : "" })} />
                </div>
                {this.inp("รหัสไปรษณีย์", "post_code", "text", null, true)}
                {this.inp("เบอร์โทร", "phone_number", "tel", 10, false, true)}
                {this.inp("เลขผู้เสียภาษี", "tax_number", "text", 13, false, true)}
                {this.imgBox("รูปโครงการ", "picture")}
                {this.imgBox("รูปหัวกระดาษ", "picture_paper")}
              </div>
              {create_r && (
                <div className="row mx-0">
                  <div className="ml-auto col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 px-2 mb-3"><button className="btn btn-outline-primary w-100" onClick={() => window.location.reload()}>ยกเลิก</button></div>
                  <div className="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 px-2 mb-3"><button className="btn btn-primary w-100" onClick={this.Update}>บันทึก</button></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}